import React from "react";

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Input: React.FC<IProps> = ({ onChange, type, ...props }) => (
  <input {...props} type={type} onChange={onChange} />
);

export default Input;
